module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BoldItalic.38845dae.ttf";